export function slideShow() {
  const slideshows = document.querySelectorAll('.image-slideshow');
  
  slideshows.forEach(function(slideshow) {
    let imagesData = slideshow.getAttribute('data-images');
    try {
      // シングルクォートをダブルクォートに置換してからJSONパース
      imagesData = JSON.parse(imagesData.replace(/'/g, '"'));
    } catch (e) {
      console.error("data-imagesの形式が正しくありません", e);
      return;
    }

    // 切り替え間隔の設定（data-interval属性があればその値を優先）
    let interval = 2000;
    if (slideshow.hasAttribute('data-interval')) {
      const attrInterval = parseInt(slideshow.getAttribute('data-interval'));
      if (!isNaN(attrInterval)) {
        interval = attrInterval;
      }
    }

    // シャッフル設定（data-shuffle属性があればそれに従う。指定がなければtrue）
    let shouldShuffle = true;
    if (slideshow.hasAttribute('data-shuffle')) {
      shouldShuffle = slideshow.getAttribute('data-shuffle').toLowerCase() === 'true';
    }

    // 画像リストをシャッフル（Fisher-Yatesアルゴリズム）
    if (shouldShuffle) {
      for (let i = imagesData.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [imagesData[i], imagesData[j]] = [imagesData[j], imagesData[i]];
      }
    }

    // 画像のプリロード処理（各オブジェクトのsrcプロパティを使用）
    imagesData.forEach(item => {
      const preloadedImage = new Image();
      preloadedImage.src = item.src;
    });

    // imgタグの生成
    const img = document.createElement('img');
    slideshow.appendChild(img);

    // キャプション表示用の要素（ここではpタグ）を生成
    const caption = document.createElement('p');
    caption.className = 'caption';
    slideshow.appendChild(caption);

    let index = 0;
    function updateImage() {
      // 画像とキャプションを更新（一瞬で切り替え）
      img.src = imagesData[index].src;
      caption.textContent = imagesData[index].caption || "";
      index = (index + 1) % imagesData.length;
    }

    // 初回表示
    updateImage();

    // 指定間隔で画像を更新
    setInterval(updateImage, interval);
  });
}